import {initializeApp} from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration

const firebaseConfig = {

    apiKey: "AIzaSyAMS60azawpYjYCDNalv4W9SsmVtu9MlgU",
  
    authDomain: "choregraph.firebaseapp.com",
  
    projectId: "choregraph",
  
    storageBucket: "choregraph.appspot.com",
  
    messagingSenderId: "241114981825",
  
    appId: "1:241114981825:web:09a710722e4181e217bb40"
  
  };
  
  
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);